import React from "react";
import "./ComingSoon.css";

const ComingSoon = () => {
  return (
    <div className="coming-soon-page fade-in">
      <div className="soon-box slide-up">
        <h1 className="slide-left">🚧 Will Be Available Soon</h1>
        <p className="slide-right">
          We're crafting something special for you. Stay tuned!
        </p>
        <span className="brand-tag slide-right">— AtelierbyShriji</span>
      </div>
    </div>
  );
};

export default ComingSoon;
